export default __webpack_public_path__ + "static/media/Pistol_7.edce05b2.png";